export default __webpack_public_path__ + "static/media/5_image_5.9fb03568.png";